import * as ng from 'angular';
import { ComponentRegistration } from '../../../core';
import { IProfileSecurityResource, IUserResource } from './../';
import { ISessionService, IToastMessageService } from './../../../services';
import { Dto } from '../../../data';
let template = require('./change-password-card.html');

class ChangePasswordCardComponent extends ComponentRegistration {

    constructor() {
        super('changePasswordCard', {
            controller: ChangePasswordCardController,
            templateUrl: template,
            controllerAs: 'password',
            bindings: {
                ngDisabled: "="
            }
        });
    }
}


interface IChangePasswordCardController {
    onSave(): void;
    onCancel(): void;
    validate(): void;
    clearForm(): void;
    changePassword(): void;
}

class ChangePasswordCardController implements IChangePasswordCardController {
    private static $inject: Array<string> = ['Session', 'User', 'toastMessageFactory'];

    //private fields
    private current: string = '';
    private new: string = '';
    private confirmed: string = '';
    private isEditMode: boolean = true;
    private passwordForm: ng.IFormController;

    //bindings
    private ngDisabled: boolean;

    constructor(private Session: ISessionService,
        private User: IUserResource,
        private toastMessageFactory: IToastMessageService) {

        console.log('ChangePasswordController loaded');

    }

    public $onInit(): void {

        console.log('ChangePasswordController activated');
    }

    public onSave(): void {
        this.changePassword();
    }

    public onCancel(): void {
        this.changePassword();
    }

    public validate(): void {
        (this.passwordForm as any).current.$;
    }

    public clearForm(): void {
        this.current = '';
        this.new = '';
        this.confirmed = '';
        this.passwordForm.$setUntouched();
    }

    public changePassword(): void {

        this.Session.getSessionAsync().then((current) => {
            if (current && current.profile) {
                var request = {
                    newPassword: this.new,
                    currentPassword: this.current
                } 

                return this.User.changePassword({ id: current.profile.id }, request).$promise
                    .then((response) => {

                        this.isEditMode = false;
                        this.clearForm();
                        this.toastMessageFactory.showSuccessMessage();
                    })
                    .catch((e) =>  {
                        (this.passwordForm as any).current.$setValidity("incorrect", true);
                        console.log(e);
                    });
            }
        });
    }
}

let chpwdcdComponent = new ChangePasswordCardComponent();
export default chpwdcdComponent;
export { chpwdcdComponent as ChangePasswordCardComponent, IChangePasswordCardController, ChangePasswordCardController }


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/components/security/user-controls/change-password-card.ts